var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"s-button",class:{
        's-button--clickable': !_vm.icon,
        's-button--active': _vm.isActive,
        's-button--active-text': !_vm.icon && _vm.isActive,
    },attrs:{"title":_vm.title,"disabled":!_vm.haveListeners}},_vm.$listeners),[_vm._t("default",[(_vm.icon)?_c('Icon',{attrs:{"name":_vm.icon}}):_vm._e(),(_vm.text)?_c('Label',{attrs:{"text":_vm.text}}):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }